module.exports = __webpack_public_path__ + "img/cooperative_bg.dd37a501.png";